import { render, staticRenderFns } from "./ozon-operation-child.vue?vue&type=template&id=0a7ad680&scoped=true&"
import script from "./ozon-operation-child.vue?vue&type=script&lang=js&"
export * from "./ozon-operation-child.vue?vue&type=script&lang=js&"
import style0 from "./ozon-operation-child.vue?vue&type=style&index=0&id=0a7ad680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ad680",
  null
  
)

export default component.exports